import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#010003] flex items-center justify-center p-4">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-12 text-center relative">
        <div className="relative">
          <h1 className="text-8xl md:text-[12rem] font-black glitch-text select-none text-transparent relative z-10">404</h1>
          <h1 className="absolute inset-0 text-8xl md:text-[12rem] font-black glitch-text-shadow select-none text-slate-100">404</h1>
          <h1 className="absolute inset-0 text-8xl md:text-[12rem] font-black glitch-text-shadow-2 select-none text-neutral-900">404</h1>
        </div>
        
        <h2 className="glitch-message text-2xl sm:text-3xl font-bold mb-4">
          Hoppla! Seite nicht gefunden
        </h2>
        
        <p className="glitch-subtitle text-gray-400 text-lg mb-8 max-w-md mx-auto">
          Die gesuchte Seite existiert nicht oder wurde verschoben.
        </p>
        
        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <Link to="/" className="btn-primary group">
            <span>Zurück zur Startseite</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="transition-transform group-hover:translate-x-1">
              <path d="M5 12h14"/>
              <path d="m12 5 7 7-7 7"/>
            </svg>
          </Link>
        </div>
        
        <div className="mt-12">
          <p className="text-sm text-gray-500">
            Hilfe benötigt? <a href="mailto:support@blcks.at" className="text-white hover:text-white-300 transition-colors">Kontaktiere unser Team</a>
          </p>
        </div>
      </div>
    </div>
  );
}
